<template>
  <div v-if="logos.length" class="tenant-brand-logos">
    <img v-for="logo in logos" :key="logo.src" :src="logo.src" :alt="$t(logo.altKey)" class="tenant-brand-logo" />
  </div>
</template>

<script setup lang="ts">
import type { BrandLogo } from '@/types/Customer'

defineProps<{
  /** The additional branding logos to display, in render order. */
  logos: BrandLogo[]
}>()
</script>

<style scoped lang="scss">
.tenant-brand-logos {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: transparent;
}

.tenant-brand-logo {
  height: 72px;
  width: auto;
  object-fit: contain;
}
</style>
